import React from "react";
import "./Codepen.css"

const Codepen = (props) => {
    return (
        <div className="code-sample appear-top">
          <h2><strong>Front-end React Code Sample</strong></h2>
          <h3><i>'React Navbar' & 'SwitchComponent' components</i></h3>
          <iframe height="300" title="React v18 Navbar and SwitchComponent" src="https://codepen.io/JonWaaler/embed/preview/VwBdBwE?default-tab=js%2Cresult" loading="lazy" allowtransparency="true">
            See the Pen <a href="https://codepen.io/JonWaaler/pen/VwBdBwE">
            React v18 Navbar and SwitchComponent</a> by Jon Waaler (<a href="https://codepen.io/JonWaaler">@JonWaaler</a>)
            on <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </div>
        );
  }
  

export default Codepen;
